import React, { useState } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { login } from "../api/consumerService";

const LoginForm = ({ onLogin }) => {
    const [loginName, setLoginName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await login({ loginName, password });
            if (res.data.data.token) {
                localStorage.setItem("Token", res.data.data.token);
                localStorage.setItem("User", res.data.data.loginName);
                onLogin && onLogin(res.data.data.loginName);
            } else {
                setError("Login failed: Token not received");
            }
        } catch (err) {
            setError("Invalid credentials");
            console.error("Login error:", err);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 overflow-hidden">
            <div className="w-full max-w-lg bg-white shadow-xl rounded-2xl p-10 flex flex-col items-center">
                {/* Logo */}
                <img
                    src="/sv.jpg"
                    alt="Company Logo"
                    className="h-48 w-auto sm:h-56 md:h-60 object-contain mb-6"
                />

                {/* Title */}
                <h3 className="text-2xl md:text-1xl text-gray-800 mb-6 text-center">
                    Consumer Management System
                </h3>

                {/* Form */}
                <form onSubmit={handleSubmit} className="w-full space-y-6">
                    <h2 className="text-x md:text-1xl font-semibold text-center text-gray-700 mb-4">
                        Login to your account
                    </h2>

                    {error && (
                        <div className="flex items-start gap-2 text-red-700 bg-red-100 border border-red-300 rounded-md p-3 text-sm">
                            <FiAlertCircle className="mt-0.5 text-red-600" />
                            <span>{error}</span>
                        </div>
                    )}

                    {/* Login Name */}
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Login Name</label>
                        <input
                            type="text"
                            value={loginName}
                            onChange={(e) => setLoginName(e.target.value)}
                            required
                            className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            placeholder="Enter your username"
                        />
                    </div>

                    {/* Password */}
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            placeholder="Enter your password"
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition"
                    >
                        Login
                    </button>

                </form>
            </div>
        </div>
    );
};

export default LoginForm;
